module.exports = __webpack_public_path__ + "media/application/images/images/bcorp-logo-b10385362bdd238a0393d40901fd07c4.png";